import { FileDownloadService } from "@topline/services/fileDownloadService";
import { ForecastSelectorPopUpComponent } from "./popups/forecastSelectorPopUpComponent";
import { ToasterService } from "@topline/services/toasterService";

(function (module) {
    "use strict";

    module.component('assumptionsStep', {
        template: require('./assumptionsStepComponent.html'),
        bindings: {
            isValid: '=',
            brands: '=',
            showValidationErrors: "=",
            stepEnter: "=",
            marketName: "<",
            isEditable: "<",
            forecastName: '<'
        },
        controller: ['$scope', ToasterService.componentName, FileDownloadService.componentName, '$uibModal', function(
            this: $TSFixMe,
            $scope: $TSFixMe,
            toasterService: ToasterService,
            fileDownloadService: FileDownloadService,
            $uibModal: ng.ui.bootstrap.IModalService
        ) {
            var $ctrl = this;

            $ctrl.tabData = {};

            $ctrl.checkValid = function () {
                var selectedTab = $ctrl.brandTabs[$ctrl.tabData.selectedTab];
                selectedTab.showValidationErrors();
            };

            $ctrl.export = (brand: $TSFixMe) => {
                toasterService.showReportGenerateBusyIndicator(() =>
                    fileDownloadService.downloadFilePost('api/forecast/assumptions', 'assumptions.docx', {
                        assumptions: brand.assumptions,
                        metadata: {
                            forecast: $ctrl.forecastName,
                            brand: brand.name,
                            molecule: brand.molecules.join(', '),
                            market: $ctrl.marketName
                        }
                    }),
                    'WORD_EXPORT_GENERATING', 'WORD_EXPORT_GENERATED');
            }

            $ctrl.importAssumptions = (brand: $TSFixMe) => {
                const modalInstance = $uibModal.open({
                    component: ForecastSelectorPopUpComponent.componentName
                });

                modalInstance.result.then(function (assumptions: $TSFixMe) {
                    brand.assumptions = assumptions;
                    
                    const b = _.find($ctrl.brands, (b: $TSFixMe) => b.name == brand.name);
                    if (b) {
                        b.assumptions = assumptions;
                    }
                }, () => { });
            }

            $ctrl.$onInit = function () {
                $ctrl.stepEnter = function () {
                    if (!$ctrl.brandTabs) {
                        
                        $ctrl.brandTabs = _.map($ctrl.brands, function (b: $TSFixMe) {
                            return {
                                assumptions: b.assumptions,
                                name: b.name,
                                molecules: b.molecules
                            };
                        });
                    }
                }

                $ctrl.showValidationErrors = function () {
                    var selectedTab = $ctrl.brandTabs[$ctrl.tabData.selectedTab];
                    if (!selectedTab.isValid) {
                        selectedTab.showValidationErrors();
                    }
                }

                $scope.$watch('$ctrl.brandTabs', function () {

                    $ctrl.isValid = angular.isUndefined($ctrl.brandTabs) ?
                        
                        _.every($ctrl.brands, (b: $TSFixMe) => isAssumptionValid(b.assumptions)) :
                        
                        _.every($ctrl.brandTabs, (b: $TSFixMe) => b.isValid);
                }, true);

                function isAssumptionValid(assumption: $TSFixMe) {
                    return assumption.marketInfoMore &&
                        assumption.productInfoMore &&
                        assumption.moleculeInfoMore &&
                        assumption.refundactionAssumptions &&
                        assumption.priceAssets &&
                        assumption.promotionalForces &&
                        assumption.promotionalForcesCompetitors;
                }
            }
        }]
    })

})(angular.module('topline.modules'));